"use client";
import dynamic from 'next/dynamic';
import React, { useState, useEffect } from "react";
import styles from "./NewsPage.module.css";

const Header = dynamic(() => import('@/Component/Header'), { ssr: false });
const Footer = dynamic(() => import('@/Component/Footer'), { ssr: false });
const TitleText = dynamic(() => import('@/Component/TitleText'));

import search_icon from "@/assets/Icon/Search_Icon.png"
import { useTranslation } from "react-i18next";
import button_image from "@/assets/Icon/Down_Icon.png";
import { useLoading } from "@/Component/LoadingContext";
import Image from "next/image";
const NewsPage = ({ db, titleTextKey }) => {
    const allItems = db.sort((a, b) => new Date(b.date.replace(/\./g, "-")) - new Date(a.date.replace(/\./g, "-")))
    const { t } = useTranslation();
    const itemsPerPage = 9;
    const [currentPage, setCurrentPage] = useState(1);
    const { show, updateProgress, progress } = useLoading();

    const [isInitialized,setIsInitialized] = useState(false);
    const [news, setNews] = useState(allItems.slice(0, 9));
    const [totalPage, setTotalPage] = useState(Math.ceil(allItems.length / itemsPerPage));
    const [searchTerm, setSearchTerm] = useState("");
    const [loadedImageCount, setLoadedImageCount] = useState(0);
    const [imageResetKey, setImageResetKey] = useState(0);
    useEffect(() => {
        // db가 바뀌면 데이터 초기화 등 처리
        setSearchTerm("");
        setNews(db.slice(0, 9));
        PageUpdate(1, "");
    }, [db]);
    useEffect(() => {
        show();
        setIsInitialized(true);
        setLoadedImageCount(0);
        
        if(news.length == 0){
            updateProgress(100);
        }
    }, [imageResetKey]);
    const PageUpdate = (pageIndex, search = searchTerm) => {
        setCurrentPage(pageIndex);
        SearchNews(search, pageIndex);
    }

    const SearchNews = (filter, page = currentPage, isSerach = false) => {
        const startIdx = (page - 1) * itemsPerPage;
        const endIdx = startIdx + itemsPerPage;
        var news = allItems.filter((item) => t(item.nameKey).toLowerCase().includes(filter ? filter.toLocaleLowerCase() : ""));
        setTotalPage(Math.ceil(news.length / itemsPerPage));
        setNews(news.slice(startIdx, endIdx))

        if(!isSerach){
        window.scrollTo(0, 0);
        setImageResetKey(prev => prev + 1);
        }
        if (Math.ceil(news.length / itemsPerPage) < currentPage) {
            setCurrentPage(1);
        }
    }
    return (
        <div className={styles.news}>
            <Header></Header>
            <div className={styles.news__container}>

                <TitleText
                    titleTextInfo={{ textKey: titleTextKey }} >
                </TitleText>

                <div className={styles.news__content}>
                    <div className={styles.search__form}>
                        <div className={styles.search__input__box}>
                            <input className={styles.serach__text__placeholder} placeholder={t("News.Search.PlaceHolder")} value={searchTerm} onChange={(e) => {
                                setSearchTerm(e.target.value);
                                SearchNews(e.target.value,1, true);
                            }} onBlur={(e) => {
                                setSearchTerm(e.target.value);
                                SearchNews(e.target.value,1, true);
                            }}>
                            </input>
                            <div className={styles.search__btn}>
                                <Image src={search_icon} className={styles.search__btn__image} alt="search icon"/>
                            </div>
                        </div>
                    </div>
                    <div className={styles.article__content}>
                        <div className={styles.article__list}>
                            {isInitialized&&news.map((item, index) => (
                                <div key={index} className={styles.article__box} onClick={() => {
                                    window.open(item.news_url);
                                }}>
                                    <img src={item.thumbnail_url} className={styles.article__thumbnail__image} alt="thumbnail"
                                        onLoad={() => {
                                            setLoadedImageCount((prev) => {
                                                const updated = prev + 1;
                                                setTimeout(() => {
                                                    const progressData = updated === news.length ? 100 : (updated / news.length) * 100;
                                                    updateProgress(progressData);
                                                }, 0);
                                                return updated;
                                            })
                                        }}
                                        onError={() => {
                                            setLoadedImageCount((prev) => {
                                                const updated = prev + 1;
                                                setTimeout(() => {
                                                    const progressData = updated === news.length ? 100 : (updated / news.length) * 100;
                                                    updateProgress(progressData);
                                                }, 0);
                                                return updated;
                                            })
                                        }}/>
                                    <div className={styles.article__text}>
                                        <span className={styles.article__title__text}>
                                            {t(item.nameKey)}
                                        </span>
                                        <span className={styles.article__date__text}>
                                            {item.date}
                                        </span>
                                    </div>
                                </div>
                            ))
                            }
                        </div>

                        <div className={styles.pagination__container}>
                            <div className={`${styles.pagination__btn}  ${(currentPage > 1 && totalPage > 0) ? styles.active : ""}`} onClick={() => {
                                PageUpdate(currentPage - 1)

                            }}>
                                <Image src={button_image} className={`${styles.pagination__btn__image} ${styles.left}`} alt="left"/>
                            </div>
                            <div className={styles.go__page}>
                                {Array.from({ length: totalPage }, (_, i) => (
                                    <div key={i} className={`${styles.go__page__btn} ${currentPage === i + 1 ? styles.active : ""}`} onClick={() => {
                                        PageUpdate(i + 1)

                                    }}>
                                        <span className={styles.go__page__btn__text}>
                                            {i + 1}
                                        </span>
                                    </div>
                                ))
                                }
                            </div>
                            <div className={`${styles.pagination__btn} ${currentPage < totalPage ? styles.active : ""}`} onClick={() => {
                                PageUpdate(currentPage + 1)
                            }}>
                                <Image loading="eager" src={button_image} className={`${styles.pagination__btn__image} ${styles.right} `} alt="right"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer></Footer>
        </div>
    )
}

export default NewsPage;